import type { Edge, Node, XYPosition } from '@xyflow/react';

export const seedNodePositions = <TNode extends Node>({
  nodes,
  edges,
  previousPositions,
}: {
  nodes: TNode[];
  edges: Edge[];
  previousPositions: ReadonlyMap<string, XYPosition>;
}): TNode[] => {
  if (previousPositions.size === 0) {
    return nodes;
  }

  const anchorByNodeId = new Map(
    edges.flatMap((edge): Array<[string, XYPosition]> => {
      const sourcePosition = previousPositions.get(edge.source);
      const targetPosition = previousPositions.get(edge.target);

      if (sourcePosition && !targetPosition) {
        return [[edge.target, sourcePosition]];
      }

      if (targetPosition && !sourcePosition) {
        return [[edge.source, targetPosition]];
      }

      return [];
    }),
  );

  return nodes.map((node) => {
    const position =
      previousPositions.get(node.id) ?? anchorByNodeId.get(node.id);

    return position ? { ...node, position } : node;
  });
};
